<script lang="ts">
  import Caret from "~icons/ph/caret-down";

  let { phone }: { phone: string } = $props();
</script>

<details>
  <summary>What if I don’t want to accept the offer?<Caret /></summary>
  <p>
    If you don’t want to accept, please call us at <a class="underline text-blue-500" href="tel:{phone}">{phone}</a>
    to discuss your options.
  </p>
</details>
